<template>
    <div class="d-flex">
        <navigator :flag="navFlag" />
        <div class="dashboard-page">
            <div class="title-header">
                <h2> Dashboard </h2>
                <div class="header-actions">
                    <button class="messages-btn" @click="openMessages">
                        💬 Messages
                        <span v-if="totalUnread" class="unread-badge">{{ totalUnread }}</span>
                    </button>
                    <button class="new-message-btn" @click="goToUsers">
                        ✚ Message a user
                    </button>
                    <button class="announcement-btn" @click="openAnnouncementModal">
                        📢 Send Announcement
                    </button>
                </div>
            </div>
            <div class="content">
                <div class="dashboard-statistics">
                    <!-- user stats -->
                    <div class="user-counts">

                        <div class="statistics-item">
                            <div class="stat-info">
                                <span>Total Playtesters</span>
                                <h3 class="fs-5">{{ totalPlaytesters }}</h3>
                            </div>
                            <div class="icon-container">
                                <img src="../../assets/controller_icon.png" alt="controller" class="stat-icon-c">
                            </div>
                        </div>

                        <div class="statistics-item">
                            <div class="stat-info">
                                <span>Online Playtesters</span>
                                <h3 class="fs-5">{{ totalOnlineTesters }}</h3>
                            </div>
                            <div class="icon-container">
                                <img src="../../assets/controller_icon.png" alt="controller" class="stat-icon-c">
                            </div>
                        </div>

                        <div class="statistics-item">
                            <div class="stat-info">
                                <span>Incomplete Profiles</span>
                                <h3 class="fs-5">{{ incompletePlaytesters }}</h3>
                            </div>
                            <div class="icon-container">
                                <img src="../../assets/edit_icon.png" alt="edit" class="stat-icon">
                            </div>
                        </div>

                        <div class="statistics-item">
                            <div class="stat-info">
                                <span>Total Developers</span>
                                <h3 class="fs-5">{{ totalDevs }}</h3>
                            </div>
                            <div class="icon-container">
                                <img src="../../assets/user_icon.png" alt="user" class="stat-icon">
                            </div>
                        </div>

                        <div class="statistics-item">
                            <div class="stat-info">
                                <span>Online Developers</span>
                                <h3 class="fs-5">{{ totalOnlineDevs }}</h3>
                            </div>
                            <div class="icon-container">
                                <img src="../../assets/user_icon.png" alt="user" class="stat-icon">
                            </div>
                        </div>

                        <div class="statistics-item">
                            <div class="stat-info">
                                <span>Unapproved Surveys</span>
                                <h3 class="fs-5">{{ unnaprovedSurveys }}</h3>
                            </div>
                            <div class="icon-container">
                                <img src="../../assets/edit_icon.png" alt="edit" class="stat-icon">
                            </div>
                        </div>

                    </div>
                    <!-- graph section -->
                    <div class="graphs">
                        <div class="graph-header">
                            <!-- Date Range Picker -->
                            <label for="start-date">Start Date:</label>
                            <input type="date" v-model="startDate" />

                            <label for="end-date">End Date:</label>
                            <input type="date" v-model="endDate" />

                            <!-- Checkbox Filters -->
                            <div class="checkboxes">
                              <span class="subgroup-1">
                                <label><input type="checkbox" v-model="showDevData" @change="toggleVisibility" /> Dev</label>
                                <label><input type="checkbox" v-model="showTesterData" @change="toggleVisibility" /> Tester</label>
                                <label><input type="checkbox" v-model="showTotalData" @change="toggleVisibility" /> Total</label>
                              </span>
                              <span class="subgroup-2">
                                <label><input type="checkbox" v-model="showActiveData" @change="toggleVisibility" /> Active</label>
                                <label><input type="checkbox" v-model="showNewData" @change="toggleVisibility" /> New</label>
                              </span>
                            </div>

                        </div>

                        <div class="graph-container">
                          <canvas v-show="!loadingGraph" id="userGraph"></canvas>
                          <div v-if="loadingGraph" class="spinner-container">
                              <div class="spinner"></div>
                              <p>Loading graph data...</p>
                          </div>
                        </div>
                    </div>

                    <UsageFunnel :startDate="startDate" :endDate="endDate" />

                </div>
                <div class="dashboard-messages">  
                    <h2 class="messages-title"> Notifications </h2>
                    <div class="notif-filters">
                      <hr class="divider">
                      <b-dropdown text="Clear" class="clear-notifs" variant="danger">
                        <b-dropdown-item v-for="opt in clearNotifLabels" :key="opt" @click="confirmClear(opt)">
                          {{ opt }}
                        </b-dropdown-item>
                      </b-dropdown>
                      <b-modal
                        v-model="showConfirmationModal"
                        title="Confirm Clear"
                        @ok="clearNotifications(clearNotifOption)"
                        ok-title="Confirm"
                        cancel-title="Cancel"
                        ok-variant="danger"
                        centered
                      >
                        <p>This action will delete Notifications <b>({{ clearNotifOption }})</b></p>
                      </b-modal>
                      <b-dropdown text="Show" class="hide-notifs" variant="danger">
                        <b-dropdown-item v-for="opt in hideNotifLabels" :key="opt" @click="updateHideOption(opt)">
                          {{ opt }}
                        </b-dropdown-item>
                      </b-dropdown>
                    </div>
                    <div class="notifications-container">
                      <div
                        v-for="item in displayedNotifications"
                        :key="item.id"
                        class="notifications notification-clickable"
                        @click="openNotificationDetail(item)"
                      >
                          <div class="notif-icon">
                            <img src="../../assets/notif_icon.png" alt="icon" class="icon-image">
                          </div>
                          <div class="notif-body">
                            <div class="notif-meta">
                              <span class="notif-card-badge">{{ typeLabelFor(item) }}</span>
                              <span class="time-passed">{{ item.timePassed }}</span>
                            </div>
                            <div class="notif-summary">{{ summaryFor(item) }}</div>
                          </div>
                      </div>
                      <div v-if="!displayedNotifications.length" class="notif-empty">
                        <img src="../../assets/notif_icon.png" alt="" class="notif-empty-icon">
                        <div class="notif-empty-text">You're all caught up</div>
                      </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Announcement Modal with Achievements Page Styling -->
        <b-modal
          v-model="showAnnouncementModal"
          title="Send Announcement to All Users"
          size="lg"
          @ok="sendAnnouncement"
          ok-title="Send Announcement"
          cancel-title="Cancel"
          ok-variant="primary"
          :ok-disabled="!announcementText.trim() || sendingAnnouncement"
          centered
          modal-class="announcement-modal-custom"
        >
          <div class="announcement-modal-content">
            <div class="announcement-info-box">
              <img src="../../assets/notif_icon.png" alt="announcement" class="announcement-icon">
              <p class="announcement-info">
                This announcement will be sent to <strong>all users</strong> (testers and developers).
                They will receive it in a dedicated admin chat that appears pinned at the top of their messages.
              </p>
            </div>
            
            <div class="form-group">
              <label for="announcement-text" class="announcement-label">Announcement Message:</label>
              <textarea
                id="announcement-text"
                v-model="announcementText"
                class="announcement-textarea"
                rows="6"
                placeholder="Type your announcement here..."
                :disabled="sendingAnnouncement"
              ></textarea>
              <small class="character-count">{{ announcementText.length }} characters</small>
            </div>

            <div v-if="sendingAnnouncement" class="sending-container">
              <div class="spinner-border-custom"></div>
              <p class="sending-text">Sending announcement to all users...</p>
            </div>

            <div v-if="announcementResult" class="result-alert" :class="announcementResult.success ? 'alert-success' : 'alert-error'">
              <strong>{{ announcementResult.success ? '✓ Success!' : '✗ Error' }}</strong>
              <p class="mb-0">{{ announcementResult.message }}</p>
            </div>
          </div>
        </b-modal>

        <b-modal
          v-model="showNotificationModal"
          title="Notification"
          centered
          hide-footer
        >
          <template #modal-header="{ close }">
            <h5 class="modal-title text-orange">Notification</h5>
            <b-button variant="outline-danger" size="sm" @click="close">X</b-button>
          </template>
          <div v-if="selectedNotification" class="notif-detail">
            <span class="notif-detail-badge">{{ selectedType.label }}</span>

            <p class="notif-detail-summary">{{ notificationSummary }}</p>

            <div
              v-for="field in visibleFields"
              :key="field.key"
              class="notif-detail-row"
            >
              <span class="notif-detail-label">{{ field.label }}</span>
              <span>{{ selectedNotification[field.key] }}</span>
            </div>
            <div class="notif-detail-row">
              <span class="notif-detail-label">Received</span>
              <span>{{ selectedNotification.timePassed }}</span>
            </div>

            <p v-if="selectedNotification.content" class="notif-detail-content">
              {{ selectedNotification.content }}
            </p>

            <div class="notif-detail-actions">
              <b-button
                variant="outline-secondary"
                @click="markNotificationDone(selectedNotification)"
              >
                Mark as Read
              </b-button>
              <b-button
                v-if="selectedAction"
                class="review-button"
                @click="runNotificationAction(selectedNotification)"
              >
                {{ selectedAction.label }}
              </b-button>
            </div>
          </div>
        </b-modal>

        <MessagePanel ref="messagePanel" :contacts="contacts" :userType="userType" />
    </div>
</template>

<script>
import navigator from '../layout/NavBarNew.vue'
import Loading from '../loading/index.vue'
import Notifications from "../../Firestore/Notifications";
import GetStats from '../../Firestore/GetStats';
import { fetchGraphData } from '../../Firestore/Graph';
import Chart from 'chart.js';
import Chat from '../../Firestore/Chat.js';
import { sendAdminAnnouncement } from '../../Firestore/NotificationDevTes.js';
import MessagePanel from '../messagebox/developer-messagepanel.vue';
import UsageFunnel from './UsageFunnel.vue';
import { getAdminNotificationType, getAdminFilterLabels, typeForFilterLabel, describeNotification, getNotificationAction } from '../../util/adminNotificationTypes';

export default {
  name: "AdminDashboard",
  components: {
    UsageFunnel,
      navigator,
      Loading,
      MessagePanel
  },
  data() {
    return {
      userId: window.localStorage.getItem("userId"),
      userType: window.localStorage.getItem("userType") ? parseInt(window.localStorage.getItem("userType")) : -1, // 0: Tester, 1: Developer, 2: Admin
      unsubscribe: null,
      notificationsObj: [],
      displayedNotifications: [],
      navFlag: 2,
      totalPlaytesters: 0,
      totalDevs: 0,
      totalOnlineDevs: 0,
      totalOnlineTesters: 0,
      incompletePlaytesters: 0,
      unnaprovedSurveys: 0,
      clearNotifLabels: ["All", "Older than 1 Hour", "Older than 1 Day", "Older than 1 Week"],
      hideNotifLabels: getAdminFilterLabels(),
      showConfirmationModal: false,
      clearNotifOption: null,
      startDate: "",
      endDate: "",
      chartInstance: null,

      // Data series toggles
      showDevData: true,
      showTesterData: true,
      showTotalData: true,
      showActiveData: true,
      showNewData: true,
      loadingGraph: false,

      // Announcement modal
      showAnnouncementModal: false,
      announcementText: "",
      sendingAnnouncement: false,
      announcementResult: null,

      // Notification detail
      showNotificationModal: false,
      selectedNotification: null,

      // Direct messaging
      contacts: [],
      conversations: [],
      conversationsUnsub: null,
    };
  },
  computed: {
    totalUnread() {
      return this.contacts.reduce((sum, c) => sum + (c.unreadCount || 0), 0);
    },
    selectedType() {
      return this.selectedNotification
        ? getAdminNotificationType(this.selectedNotification.type)
        : { label: "", fields: [] };
    },
    notificationSummary() {
      return this.selectedNotification
        ? describeNotification(this.selectedNotification)
        : "";
    },
    visibleFields() {
      if (!this.selectedNotification) return [];
      return this.selectedType.fields.filter(
        field => this.selectedNotification[field.key]
      );
    },
    selectedAction() {
      return this.selectedNotification
        ? getNotificationAction(this.selectedNotification)
        : null;
    },
  },
  mounted() {
      // redirect to login if the user is not logged in
      if (window.localStorage.getItem("userType")) {
          this.userType = parseInt(window.localStorage.getItem("userType"));
      } else {
          this.$router.push({
              name: 'login',
          })
      };

      this.fetchUserCounts();
      this.fetchAndRenderGraph();
      this.loadNotifications();
      this.loadConversations();
  },
  beforeDestroy() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
    }
    if (this.conversationsUnsub) {
      this.conversationsUnsub();
      this.conversationsUnsub = null;
    }
  },
  methods: {
    openNotificationDetail(item) {
      this.selectedNotification = item;
      this.showNotificationModal = true;
    },
    markNotificationDone(item) {
      this.showNotificationModal = false;
      Notifications.deleteNotificationById(item.id)
        .catch(e => console.log(e));
    },
    goToUsers() {
      this.$router.push({ name: "users" });
    },
    openMessages() {
      if (this.$refs.messagePanel) this.$refs.messagePanel.isOpen = true;
    },
    loadConversations() {
      Chat.getUserConversations(this.userId, result => {
        if (result.success) {
          this.conversations = result.data.filter(c => c.isAdminChat !== true);
          this.transformConversationsToContacts();
        }
      })
        .then(res => {
          if (res && res.unsubscribe) this.conversationsUnsub = res.unsubscribe;
        })
        .catch(error => console.error("Error loading conversations:", error));
    },
    transformConversationsToContacts() {
      const currentUserId = this.userId;
      const contactsArray = [];

      const promises = this.conversations.map(conversation => {
        const otherUserId = (conversation.participants || []).filter(id => id !== currentUserId)[0];
        if (!otherUserId) return Promise.resolve();

        return Chat.getUserInfo(otherUserId)
          .then(userResult => {
            if (!userResult.success) return;
            const userData = userResult.data;
            contactsArray.push({
              id: otherUserId,
              conversationId: conversation.conversationId,
              type: 'user',
              name: userData.userName || userData.nickName || userData.email || 'Unknown User',
              avatar: userData.img || require('../../assets/avator_example.jpg'),
              lastMessage: conversation.lastMessage || 'No messages yet',
              lastMessageAt: conversation.lastMessageAt,
              unreadCount: (conversation.unreadCount && conversation.unreadCount[currentUserId]) || 0,
            });
          })
          .catch(() => {});
      });

      Promise.all(promises).then(() => {
        const getTime = ts => {
          if (!ts) return 0;
          if (ts.toDate) return ts.toDate().getTime();
          if (ts instanceof Date) return ts.getTime();
          return 0;
        };
        contactsArray.sort((a, b) => getTime(b.lastMessageAt) - getTime(a.lastMessageAt));
        this.contacts = contactsArray;
      });
    },
    async fetchAndRenderGraph() {
      // Ensure dates are selected
      if (!this.startDate || !this.endDate) return;

      this.loadingGraph = true;

      // Fetch labels and data
      try {
        const { labels,
                devDauData, devNewData,
                testerNewData, testerDauData,
                totalDauData, totalNewAccData } = await fetchGraphData(this.startDate, this.endDate);

                this.loadingGraph = false;
                await this.$nextTick();
                this.renderGraph(labels, devDauData, devNewData, testerNewData, testerDauData, totalDauData, totalNewAccData);
      } catch (error) {
        console.error("Failed to fetch and render graph:", error);
        this.loadingGraph = false;
      }
    },
    renderGraph(labels, devDauData, devNewData, testerNewData, testerDauData, totalDauData, totalNewAccData) {
      const ctx = document.getElementById('userGraph').getContext('2d');
      
      if (this.chartInstance) {
         // Clear previous instance
        this.chartInstance.destroy();
      }

      this.chartInstance = new Chart(ctx, {
        type: 'line',
        data: {
          labels: labels,
          datasets: [
            { label: "Active Devs", data: devDauData, borderColor: '#FFC107', fill: false, tension: 0.1, hidden: !this.showDevData || !this.showActiveData },
            { label: "New Devs", data: devNewData, borderColor: '#FF5722', fill: false, tension: 0.1, hidden: !this.showDevData || !this.showNewData },
            { label: "Active Testers", data: testerDauData, borderColor: '#4CAF50', fill: false, tension: 0.1, hidden: !this.showTesterData || !this.showActiveData },
            { label: "New Testers", data: testerNewData, borderColor: '#2196F3', fill: false, tension: 0.1, hidden: !this.showTesterData || !this.showNewData },
            { label: "Active Users", data: totalDauData, borderColor: '#9C27B0', fill: false, tension: 0.1, hidden: !this.showTotalData || !this.showActiveData },
            { label: "New Users", data: totalNewAccData, borderColor: '#607D8B', fill: false, tension: 0.1, hidden: !this.showTotalData || !this.showNewData }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [{
              ticks: {
                maxTicksLimit: 20,
                autoSkip: true,
              },
              gridLines: {
                display: false
              }
            }],
            yAxes: [{
              ticks: {
                beginAtZero: true,
              }
            }]
          }
        }
      });
    },
    async fetchUserCounts() {
      try {
        // Fetch total playtesters
        this.totalPlaytesters = await GetStats.getTotalPlaytesters();
        console.log(`Total Playtesters: ${this.totalPlaytesters}`);

        // Fetch total developers
        this.totalDevs = await GetStats.getTotalDevs();
        console.log(`Total Developers: ${this.totalDevs}`);

        // Fetch online counts same as above
        this.totalOnlineDevs = await GetStats.getOnlineDevs();
        this.totalOnlineTesters = await GetStats.getOnlineTesters();
        this.unnaprovedSurveys = await GetStats.getUnapprovedSurveys();
        this.incompletePlaytesters = await GetStats.getIncompleteTesters();
        console.log(`Incomplete Playtesters: ${this.incompletePlaytesters}`);
        
      } catch (error) {
        console.error("Failed to fetch user counts:", error);
      }
    },
    loadNotifications() {
      this.unsubscribe = Notifications.watchUserNotifications(this.userId, res => {
        if (res.success) {
          this.notificationsObj = res.data;
          this.displayedNotifications = res.data;
        }
      });
    },
    toggleVisibility() {
      if (this.chartInstance) {
        const datasets = this.chartInstance.data.datasets;
        
        datasets[0].hidden = !(this.showDevData && this.showActiveData);
        datasets[1].hidden = !(this.showDevData && this.showNewData);
        datasets[2].hidden = !(this.showTesterData && this.showActiveData);
        datasets[3].hidden = !(this.showTesterData && this.showNewData);
        datasets[4].hidden = !(this.showTotalData && this.showActiveData);
        datasets[5].hidden = !(this.showTotalData && this.showNewData);

        this.chartInstance.update();
      }
    },
    async clearNotifications(option) {
      // This is a heavy function, but it shouldn't be called too often
      Notifications.deleteUserNotifications(this.userId, option)
        .catch(e => console.log(e.error));
    },
    confirmClear(option) {
      this.clearNotifOption = option;
      this.showConfirmationModal = true;
    },
    updateHideOption(option) {
      const type = typeForFilterLabel(option);
      this.displayedNotifications = type
        ? this.notificationsObj.filter(notification => notification.type === type)
        : this.notificationsObj;
    },
    typeLabelFor(item) {
      return getAdminNotificationType(item.type).label;
    },
    summaryFor(item) {
      return describeNotification(item) || item.title || "Notification";
    },
    runNotificationAction(item) {
      const action = getNotificationAction(item);
      if (!action) return;

      this.showNotificationModal = false;

      if (action.clearOnClick) {
        Notifications.deleteNotificationById(item.id).catch(e => console.log(e));
      }

      if (action.target === "messages") {
        this.openMessages();
        return;
      }

      const routes = {
        surveys: "/surveys",
        users: "/users",
        projects: "/adminprojects",
      };
      const path = routes[action.target];
      if (path && this.$route.path !== path) {
        this.$router.push(path);
      }
    },

    // Announcement methods
    openAnnouncementModal() {
      this.showAnnouncementModal = true;
      this.announcementText = "";
      this.announcementResult = null;
    },
    
    async sendAnnouncement(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();

      if (!this.announcementText.trim()) {
        this.announcementResult = {
          success: false,
          message: "Please enter an announcement message."
        };
        return;
      }

      this.sendingAnnouncement = true;
      this.announcementResult = null;

      try {
        const result = await sendAdminAnnouncement(
          this.userId,
          this.announcementText
        );

        if (result.success) {
          this.announcementResult = {
            success: true,
            message: `Announcement sent successfully to ${result.data.successCount} users!`
          };

          // Close modal after 2 seconds
          setTimeout(() => {
            this.showAnnouncementModal = false;
            this.announcementText = "";
            this.announcementResult = null;
          }, 2000);
        } else {
          this.announcementResult = {
            success: false,
            message: "Failed to send announcement. Please try again."
          };
        }
      } catch (error) {
        console.error("Error sending announcement:", error);
        this.announcementResult = {
          success: false,
          message: `Error: ${error.error || error.message || "Unknown error"}`
        };
      } finally {
        this.sendingAnnouncement = false;
      }
    }
  },
  watch: {
    // Watch for changes in startDate, endDate, and selectedMetric
    startDate() { this.fetchAndRenderGraph();  },
    endDate() { this.fetchAndRenderGraph();  },
  }
}
</script>

<style scoped>
.dashboard-page {
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  width: 100%;
  height: 100vh;
  max-height: 100vh;
  background-color: #EEEEEE;
}

.content{
  display:flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
}

.title-header {
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 75px;
  box-shadow: 0 4px 10px -6px grey;
  position: relative;
}

.title-header h2 {
  color: #FF7222;
  font-weight: bold;
}

.notification-clickable {
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-radius: 8px;
}

.notification-clickable:hover {
  background-color: rgba(255, 114, 34, 0.08);
}

.header-actions {
  position: absolute;
  right: 30px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.messages-btn,
.new-message-btn {
  background: white;
  color: #FF7222;
  border: 2px solid #FF7222;
  padding: 10px 20px;
  border-radius: 12px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
}

.messages-btn:hover,
.new-message-btn:hover {
  background: #FF7222;
  color: white;
}

.unread-badge {
  background: #d83b3b;
  color: white;
  border-radius: 10px;
  padding: 1px 7px;
  font-size: 12px;
  margin-left: 6px;
}

.notif-detail-badge {
  display: inline-block;
  background: rgba(255, 114, 34, 0.12);
  color: #FF7222;
  border-radius: 10px;
  padding: 2px 10px;
  font-size: 0.8rem;
  font-weight: bold;
  margin-bottom: 15px;
}

.notif-detail-title {
  color: #f97427;
  font-weight: bold;
  margin-bottom: 15px;
}

.notif-detail-summary {
  color: black;
  margin-bottom: 18px;
  line-height: 1.5;
}

.notif-detail-row {
  display: flex;
  gap: 10px;
  margin-bottom: 8px;
  color: black;
}

.notif-detail-label {
  color: #f97427;
  font-weight: bold;
  min-width: 80px;
  flex-shrink: 0;
}

.notif-detail-content {
  color: black;
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #e0e0e0;
}

.notif-detail-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.review-button {
  background-color: #f97427;
  color: white;
  border: none;
}

.text-orange {
  color: #f97427;
}

.modal-header button {
  margin-left: auto;
}

/* Achievements Page Styled Button */
.announcement-btn {
  background: linear-gradient(135deg, #ffa26c, #FF7222);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 12px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  box-shadow: 0 4px 12px rgba(255, 114, 34, 0.3);
}

.announcement-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(255, 114, 34, 0.4);
  background: linear-gradient(135deg, #ffb380, #ff8336);
}

.announcement-btn:active {
  transform: translateY(0);
}

/* Achievements Page Styled Modal */
.announcement-modal-content {
  padding: 15px;
}

.announcement-info-box {
  background: linear-gradient(135deg, rgba(255, 162, 108, 0.1), rgba(255, 114, 34, 0.1));
  border-left: 4px solid #FF7222;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.announcement-icon {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
}

.announcement-info {
  margin: 0;
  color: #444;
  font-size: 14px;
  line-height: 1.5;
}

.announcement-label {
  font-weight: bold;
  color: #FF7222;
  margin-bottom: 8px;
  display: block;
}

.announcement-textarea {
  resize: vertical;
  min-height: 120px;
  font-size: 14px;
  border: 2px solid rgba(255, 162, 108, 0.3);
  border-radius: 12px;
  padding: 12px;
  width: 100%;
  transition: border-color 0.3s;
}

.announcement-textarea:focus {
  outline: none;
  border-color: #FF7222;
  box-shadow: 0 0 0 3px rgba(255, 114, 34, 0.1);
}

.character-count {
  display: block;
  text-align: right;
  color: #888;
  margin-top: 6px;
  font-size: 12px;
}

.sending-container {
  text-align: center;
  margin-top: 20px;
  padding: 20px;
  background: linear-gradient(135deg, rgba(255, 162, 108, 0.05), rgba(255, 114, 34, 0.05));
  border-radius: 12px;
}

.spinner-border-custom {
  border: 4px solid rgba(255, 162, 108, 0.2);
  border-top: 4px solid #FF7222;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 0 auto 12px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.sending-text {
  margin: 0;
  color: #666;
  font-weight: 500;
}

.result-alert {
  margin-top: 20px;
  padding: 16px;
  border-radius: 12px;
  font-size: 14px;
}

.result-alert.alert-success {
  background: linear-gradient(135deg, rgba(76, 175, 80, 0.1), rgba(56, 142, 60, 0.1));
  border: 2px solid #4CAF50;
  color: #2e7d32;
}

.result-alert.alert-error {
  background: linear-gradient(135deg, rgba(244, 67, 54, 0.1), rgba(211, 47, 47, 0.1));
  border: 2px solid #f44336;
  color: #c62828;
}

.result-alert strong {
  display: block;
  margin-bottom: 4px;
}

.messages-title {
  color: #FF7222;
  font-weight: bold;
  padding-top: 5%;
}

hr.divider {
  border: none;
  height: 2px;
  background-color: rgb(33, 37, 41);
  margin: 20px 0;
}

.dashboard-messages {
  background-color: white;
  width: 25%;
  min-height: 540px;
  min-width: 250px;
  flex-shrink: 1;
  display: flex;
  flex-direction: column;
  margin: 2% 2% 2% 2%;
  align-items: center;
  border-radius: 30px; 
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}
.notifications-container, .content {
  overflow-y: auto;
  overflow-x: hidden;
}
.notifications-container {
  width: 100%;
  border-right: 1px solid #e0e0e0;
}

.content {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

.dashboard-statistics {
    display: flex;
    flex-direction: column;
    width: 75%;
    margin: 2% 0% 2% 2%;
}

.user-counts {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 20px;
  background-color: white;
  border-radius: 30px;
  padding: 3%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  min-height: 240px;
  min-width: 650px;
  grid-auto-flow: row;
}

.statistics-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #ffa26c, #FFFFFF);
  border-radius: 12px;
  padding: 10px 20px;
  width: 180px;
  height: 80px; 
  box-shadow: 1px 1px 1px #eeb77d;
  margin: 0 auto;
  text-align: center;
}

.stat-info {
  display: flex;
  flex-direction: column; 
  align-items: center; 
  text-align: center;
}

.stat-info span {
  font-size: 90%;
  font-weight: bold;
  color: #444;
}

.stat-info h3 {
  font-weight: bold;
  color: #e94e77;
}

.icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 15px;
}

.stat-icon {
  width: 40px;
  height: 40px;
}

.stat-icon-c {
  width: 55px;
  height: 40px;
}

.graphs {
    background-color: white;
    flex-grow: 2;
    margin-top: 2%;
    min-height: 300px;
    min-width: 650px;
    border-radius: 30px; 
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.graph-header {
  display: flex;
  gap: 10px;
  margin: 1% 1% 1% 3%;
}

.graph-container {
  width: 100%;
  height: 80%;
  padding-left: 2%;
  padding-right: 2%;
}
.notif-filters {
  width: 90%;
  margin-bottom: 2%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2%;
}
.clear-notifs, .hide-notifs {
  margin-top: 3%;
}
.notifications {
  width: 90%;
  display: flex;
  flex-direction: row;
  background-color: transparent !important;
  border: 1px solid #ccc !important;
  margin: 3.5%;
  padding: 0.5rem 0.5rem;
  border-radius: 15px !important;
  justify-content: space-between;
  align-items: flex-start;
  box-shadow: 1px 1px 1px 1px rgba(199, 195, 197, 0.827);
}
.notif-body {
  display: flex;
  flex: 1;
  min-width: 0;
  margin-left: 3%;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
}
.notif-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 40px;
}
.icon-image {
  height: 70%;
  width: 70%;
}
.notif-title {
  color: #000 !important;
  font-size: 0.9rem;
  font-weight: bold;
  overflow-wrap: anywhere;
}
.time-passed {
  color: rgba(128, 128, 128, 0.695);
  font-size: 0.75rem;
  white-space: nowrap;
}
.notif-body {
  flex: 1;
  min-width: 0;
}
.notif-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}
.notif-card-badge {
  display: inline-block;
  background: rgba(255, 114, 34, 0.12);
  color: #FF7222;
  border-radius: 10px;
  padding: 1px 8px;
  font-size: 0.7rem;
  font-weight: bold;
  white-space: nowrap;
}
.notif-summary {
  color: #000;
  font-size: 0.85rem;
  line-height: 1.35;
  overflow-wrap: anywhere;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.notif-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  opacity: 0.45;
}
.notif-empty-icon {
  width: 32px;
  height: 32px;
  margin-bottom: 10px;
  filter: grayscale(100%);
}
.notif-empty-text {
  font-size: 0.85rem;
  color: #666;
}
.subgroup-1 {
  color: darkred;
  padding-right: 10px;
}

.spinner-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.spinner {
  border: 8px solid #f3f3f3;
  border-top: 8px solid #3498db;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}
</style>


// WEBPACK FOOTER //
// src/components/admin-only/AdminDashboard.vue